var _ = require('lodash');
var React = require('react');
var ReactDOM = require('react-dom');
var ItemsSelector = require('components/items_selector/items_selector');
import Confirm from 'components/confirm';
var {MODAL_PREFIX} = require('./constants.js');

const UNSUBSCRIBE_MODAL = 'unsubscribe-user';
const UNSUBSCRIBE_MODAL_TRIGGER = MODAL_PREFIX + UNSUBSCRIBE_MODAL;

class ComponentToggler extends React.Component {
  componentDidMount() {
    $(ReactDOM.findDOMNode(this)).parents('form').submit((e) => {
      if (this._allUntoggled()) {
        this._triggerModal(UNSUBSCRIBE_MODAL_TRIGGER, e);
      }
    });
  }

  _allUntoggled() {
    return _.every($('.grouped-item'), (item) => {
      return !$(item).hasClass('active')
    });
  }

  _triggerModal(modalId, e) {
    e.preventDefault();
    e.stopPropagation();
    $(ReactDOM.findDOMNode(this)).find('#' + modalId).modal();
  }

  _submit() {
    const $form = $(ReactDOM.findDOMNode(this)).parents('form')
    $form.unbind();
    $form.submit();
  }

  render() {
    return (
      <div>
        <ItemsSelector {...this.props} />
        <Confirm id={UNSUBSCRIBE_MODAL}
                 title="Hey! Just so you know..."
                 message="This will unsubscribe this user from all updates. Are you sure you want to do that?"
                 onConfirm={this._submit.bind(this)}
                 confirm_text="Unsubscribe User"
        />
      </div>
    );
  }
}

module.exports = ComponentToggler;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/component_groups.jsx